// Google Analytics (GA4) への計測イベント送信。
//
// gtag 本体は public/index.html で読み込む。本番ドメイン以外(検証環境・ローカル)では
// 読み込まれないため、そこでは window.gtag が undefined になり、本モジュールは何もしない。
// 計測の失敗が解析機能そのものに影響しないよう、例外はすべて握りつぶす。

export const isTrackingEnabled = () =>
    typeof window !== 'undefined' && typeof window.gtag === 'function';

export const trackEvent = (name, params = {}) => {
    if (!isTrackingEnabled()) return;
    try {
        // undefined の値は送らない(GA4 側で不要なパラメータが増えるのを避ける)
        const cleaned = Object.fromEntries(
            Object.entries(params).filter(([, v]) => v !== undefined && v !== null)
        );
        window.gtag('event', name, cleaned);
    } catch (e) {
        // 計測は best effort。失敗しても本体の動作は止めない
    }
};
